function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React from 'react';
import cn from 'classnames';
import { components } from 'react-select';
import Icon from '../../icon/Icon';
var Option = function(props) {
    var _props_data;
    return ((_props_data = props.data) === null || _props_data === void 0 ? void 0 : _props_data.__isNew__) ? /*#__PURE__*/ React.createElement("div", _object_spread({
        className: cn('CreateOption center-content', {
            isFocused: props.isFocused
        })
    }, props.innerProps), /*#__PURE__*/ React.createElement(Icon, {
        icon: "plus"
    }), props.data.label) : /*#__PURE__*/ React.createElement(components.Option, props);
};
export default Option;
